export default {
  methods: {
    listMRI(id) {
      var MRIArray = [[0, 1], [0, 0], [2, 0], [2, 1], [1, 0]];

      if (id == 'stage' || id == 'hgb') {
        if (id == 'hgb') {
          document.MRIForm.MRIStage.selectedIndex = document.MRIForm.MRIHgb.selectedIndex;
        }

        var a = document.MRIForm.MRIStage.selectedIndex;
        document.MRIForm.MRIT1.selectedIndex = MRIArray[a][0];
        document.MRIForm.MRIT2.selectedIndex = MRIArray[a][1];
        document.MRIForm.MRIHgb.selectedIndex = a;
      } else {
        if (id == 'T1') {
          if (document.MRIForm.MRIT1.selectedIndex == 1) {
            document.MRIForm.MRIT2.selectedIndex = 0;
          }

          ;
        }

        if (id == 'T2') {
          if (document.MRIForm.MRIT2.selectedIndex == 1 && document.MRIForm.MRIT1.selectedIndex == 1) {
            document.MRIForm.MRIT1.selectedIndex = 0;
          }
        }

        var b = document.MRIForm.MRIT1.selectedIndex;
        var c = document.MRIForm.MRIT2.selectedIndex;

        for (var i = 0; i < 5; i++) {
          if (MRIArray[i][0] == b && MRIArray[i][1] == c) {
            document.MRIForm.MRIStage.selectedIndex = i;
            document.MRIForm.MRIHgb.selectedIndex = i;
            break;
          }
        }
      }
    }

  },
  id: '6263d58d7c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=MRIblood><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>MRI Blood</div></div></div><div class=page-content><form name=MRIForm><div class=block-header>STAGE</div><div class="list simple-list"><ul><li><div class=item-input-wrap><select name=MRIStage @change="listMRI(\'stage\');"><option value="Hyperacute &lt; 24 hours" selected=selected>Hyperacute &lt; 24 hours</option><option value="Acute 1-3 days">Acute 1-3 days</option><option value="Early Subacute &gt; 3 days">Early Subacute &gt; 3 days</option><option value="Late Subacute &gt; 7 days">Late Subacute &gt; 7 days</option><option value="Chronic &gt; 14 days">Chronic &gt; 14 days</option></select></div></li></ul></div><div class=block-header>MRI T1 and T2</div><div class="list simple-list"><ul><li><div class=item-input-wrap><select name=MRIT1 @change="listMRI(\'T1\');"><option value="T1: Isointense" selected=selected>T1: Isointense</option><option value="T1: Hypointense">T1: Hypointense</option><option value="T1: Hyperintense">T1: Hyperintense</option></select></div></li><li><div class=item-input-wrap><select name=MRIT2 @change="listMRI(\'T2\');"><option value="T2: Hypointense">T2: Hypointense</option><option value="T2: Hyperintense" selected=selected>T2: Hyperintense</option></select></div></li></ul></div><div class=block-footer>Note: choices auto-limited to 5 possible stages</div><div class=block-header>CELLULAR</div><div class="list simple-list"><ul><li><div class=item-input-wrap><select name=MRIHgb @change="listMRI(\'hgb\');"><option value="Intracellular Oxyhemoglobin" selected=selected>Intracellular Oxyhemoglobin</option><option value="Intracellular Deoxyhemoglobin">Intracellular Deoxyhemoglobin</option><option value="Intracellular Methemoglobin">Intracellular Methemoglobin</option><option value="Extracellular Methemoglobin">Extracellular Methemoglobin</option><option value="Extracellular Hemosiderin">Extracellular Hemosiderin</option></select></div></li></ul></div></form></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};